import React, {useContext} from 'react';
import * as R from 'ramda';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Nav, NavItem, Button} from 'reactstrap';
import Detail from '@/internal/pages/Revenue/Detail';
import Summary from '@/internal/pages/Revenue/Summary/index';
import PayIn from '@/internal/pages/Revenue/Payin/index';
import PayOut from '@/internal/pages/Revenue/Payout/index';
import {LocaleNavLink} from '@/routes';
import RevenueProvider from '@/internal/pages/Revenue/state';
import AmoebaLink from '@/components/AmoebaLink';
import * as api from '@/internal/apis';
import useAPI from '@/hooks/useAPI';
import {RevenueCtx} from '@/contexts';

const ControlItem = ({match}) => {
  const revenue = useContext(RevenueCtx);
  const {trigger, result} = useAPI(api.deleteRevenue, {pending: true});

  if (R.pathOr(false, ['data', 'success'], result)) {
    window.location.href = `${
      process.env.REACT_APP_AMOEBA_URL
    }/revenues?flash=${R.pathOr(false, ['data', 'success'], result)}`;
  }

  return (
    <>
      {R.propOr(false, 'editable', revenue) && (
        <AmoebaLink
          href={`/revenues/${match.params.id}/edit`}
          className='btn btn-primary py-1 px-2 m-1'
        >
          Edit
        </AmoebaLink>
      )}

      {R.propOr(false, 'deletable', revenue) && (
        <Button
          className='btn btn-danger py-1 px-2 m-1'
          onClick={() => {
            if (window.confirm('Are you sure?')) {
              trigger(match.params.id);
            }
            return null;
          }}
        >
          Delete
        </Button>
      )}

      <AmoebaLink href='/revenues'>Index</AmoebaLink>
    </>
  );
};

const Revenue = ({match}) => (
  <RevenueProvider match={match}>
    <Detail />
    <ControlItem match={match} />
    <Nav tabs className='mt-4'>
      <NavItem>
        <LocaleNavLink to={`${match.url}/summary`}>Summary</LocaleNavLink>
      </NavItem>
      <NavItem>
        <LocaleNavLink to={`${match.url}/payin`}>PayIn</LocaleNavLink>
      </NavItem>
      <NavItem>
        <LocaleNavLink to={`${match.url}/payout`}>PayOut</LocaleNavLink>
      </NavItem>
    </Nav>
    <Switch>
      <Route strict exact path={`${match.path}/summary`} component={Summary} />
      <Route strict exact path={`${match.path}/payin`} component={PayIn} />
      <Route strict exact path={`${match.path}/payout`} component={PayOut} />
      <Redirect to={`${match.url}/summary`} />
    </Switch>
  </RevenueProvider>
);

export default Revenue;
